import * as actionTypes from "./actionTypes";

// Bank List
export const loadMerchantBankList = () => {
  return {
    type: actionTypes.LOAD_MERCHANT_BANK_LIST
  };
};

export const loadMerchantBankListSuccess = data => {
  return {
    type: actionTypes.LOAD_MERCHANT_BANK_LIST_SUCCESS,
    data
  };
};

export const loadMerchantBankListFail = () => {
  return {
    type: actionTypes.LOAD_MERCHANT_BANK_LIST_FAIL
  };
};
// END Bank List
